import { useState } from "react";
import { toast } from "sonner";
import { BookOpen, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { api, API } from "@/lib/api";

export const GuidaJrButton = ({ className = "" }) => {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ email: "", name: "" });
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/guida/wild-chef-jr/lead", { email: form.email, name: form.name || null });
      toast.success("Guida in arrivo! Controlla anche la tua email 📬");
      setOpen(false);
      window.open(`${API}/guida/wild-chef-jr`, "_blank", "noopener");
    } catch {
      toast.error("Errore, riprova.");
    } finally {
      setSending(false);
    }
  };

  return (
    <>
      <button onClick={() => setOpen(true)} data-testid="guida-jr-button"
        className={`flex items-center gap-1.5 text-[11px] uppercase tracking-[0.15em] text-[#E4BD44] hover:underline underline-offset-4 ${className}`}>
        <BookOpen size={13} /> Scarica la guida gratis
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-[#141414] border-[#2A2A2A] text-[#FCFCFC] max-w-md" data-testid="guida-jr-dialog">
          <DialogHeader>
            <DialogTitle className="font-display text-2xl">La guida gratuita Wild Chef Jr</DialogTitle>
            <DialogDescription className="text-xs text-[#9a9484]">
              5 pagine illustrate in stile manga con la ricetta esclusiva degli Spiedini Arcobaleno.
              Lasciaci la tua email e scaricala subito.
            </DialogDescription>
          </DialogHeader>
          <form onSubmit={submit} className="flex flex-col gap-3">
            <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} maxLength={80}
              placeholder="Il tuo nome (facoltativo)" data-testid="guida-jr-name"
              className="bg-[#0A0A0A] border border-[#2A2A2A] px-4 py-3 text-sm focus:outline-none focus:border-[#E4BD44]" />
            <input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
              placeholder="La tua email *" data-testid="guida-jr-email"
              className="bg-[#0A0A0A] border border-[#2A2A2A] px-4 py-3 text-sm focus:outline-none focus:border-[#E4BD44]" />
            <button type="submit" disabled={sending} className="btn-primary justify-center disabled:opacity-60" data-testid="guida-jr-submit">
              {sending && <Loader2 size={15} className="animate-spin" />} Scarica la guida
            </button>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
};
